import React from "react";
import { useState, useEffect } from "react";

import { Routes, Route } from "react-router-dom";
import App from "./App";        // الصفحة الرئيسية
import Auth from "./pages/auth"; // صفحة Login

const AppRoutes = () => {
      const [userName, setUserName] = useState<string | null>(() => {
        // استعادة حالة تسجيل الدخول من localStorage عند التحميل
        return localStorage.getItem("userName");
      });

  return (
    <Routes>
      <Route
        path="/"
        element={<Auth setUserName={setUserName} />}
      />
      <Route
        path="/dashboard"
        element={<App userName={userName} setUserName={setUserName} />}
      />
      <Route
        path="/test-ai"
        element={<App userName={userName} setUserName={setUserName} />}
      />
    </Routes>
  );
};

export default AppRoutes;
